'use client';

import React from 'react';

export function LoadingSpinner() {
  return (
    <div className="vibecode-loading-spinner fixed bottom-4 right-4 p-3 bg-white dark:bg-gray-800 rounded-lg shadow-lg">
      <div className="flex items-center space-x-2">
        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-primary"></div>
        <span className="text-sm text-gray-600 dark:text-gray-400">
          Loading Vibecode DevTools...
        </span>
      </div>
    </div>
  );
}